import { useSelector } from 'react-redux';
import { TRootStateType } from '../types';
import { ReduxState } from 'reducers';

export default function useReduxSelector<T = ReduxState>(selector: (state: TRootStateType) => T) {
  return useSelector<TRootStateType, T>(selector);
}
